import { render, staticRenderFns } from "./floorFeeSummary.vue?vue&type=template&id=d475f138&scoped=true"
import script from "./floorFeeSummary.vue?vue&type=script&lang=js"
export * from "./floorFeeSummary.vue?vue&type=script&lang=js"
import style0 from "./floorFeeSummary.vue?vue&type=style&index=0&id=d475f138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d475f138",
  null
  
)

export default component.exports